"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdditionalCost = _interopRequireDefault(require("./AdditionalCost"));
var _QuoteResponseAlternatePartInfo = _interopRequireDefault(require("./QuoteResponseAlternatePartInfo"));
var _QuoteResponseLineQuantity = _interopRequireDefault(require("./QuoteResponseLineQuantity"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The QuoteResponseLine model module.
 * @module model/QuoteResponseLine
 * @version 0.0.1
 */
var QuoteResponseLine = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>QuoteResponseLine</code>.
   * @alias module:model/QuoteResponseLine
   */
  function QuoteResponseLine() {
    _classCallCheck(this, QuoteResponseLine);
    QuoteResponseLine.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(QuoteResponseLine, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>QuoteResponseLine</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuoteResponseLine} obj Optional instance to populate.
     * @return {module:model/QuoteResponseLine} The populated <code>QuoteResponseLine</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new QuoteResponseLine();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('nsn')) {
          obj['nsn'] = _ApiClient["default"].convertToType(data['nsn'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('part_number')) {
          obj['part_number'] = _ApiClient["default"].convertToType(data['part_number'], 'String');
        }
        if (data.hasOwnProperty('weight_per_uom')) {
          obj['weight_per_uom'] = _ApiClient["default"].convertToType(data['weight_per_uom'], 'Number');
        }
        if (data.hasOwnProperty('minimum_order_quantity')) {
          obj['minimum_order_quantity'] = _ApiClient["default"].convertToType(data['minimum_order_quantity'], 'Number');
        }
        if (data.hasOwnProperty('coo')) {
          obj['coo'] = _ApiClient["default"].convertToType(data['coo'], 'String');
        }
        if (data.hasOwnProperty('no_quote_classification')) {
          obj['no_quote_classification'] = _ApiClient["default"].convertToType(data['no_quote_classification'], 'String');
        }
        if (data.hasOwnProperty('no_quote_other_reason')) {
          obj['no_quote_other_reason'] = _ApiClient["default"].convertToType(data['no_quote_other_reason'], 'String');
        }
        if (data.hasOwnProperty('will_advise_dt')) {
          obj['will_advise_dt'] = _ApiClient["default"].convertToType(data['will_advise_dt'], 'Date');
        }
        if (data.hasOwnProperty('quantities')) {
          obj['quantities'] = _ApiClient["default"].convertToType(data['quantities'], [_QuoteResponseLineQuantity["default"]]);
        }
        if (data.hasOwnProperty('alternate_nsn')) {
          obj['alternate_nsn'] = _QuoteResponseAlternatePartInfo["default"].constructFromObject(data['alternate_nsn']);
        }
        if (data.hasOwnProperty('alternate_part_number')) {
          obj['alternate_part_number'] = _QuoteResponseAlternatePartInfo["default"].constructFromObject(data['alternate_part_number']);
        }
        if (data.hasOwnProperty('additional_costs')) {
          obj['additional_costs'] = _ApiClient["default"].convertToType(data['additional_costs'], [_AdditionalCost["default"]]);
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} id
 */
QuoteResponseLine.prototype['id'] = undefined;

/**
 * @member {String} nsn
 */
QuoteResponseLine.prototype['nsn'] = undefined;

/**
 * @member {String} description
 */
QuoteResponseLine.prototype['description'] = undefined;

/**
 * @member {String} part_number
 */
QuoteResponseLine.prototype['part_number'] = undefined;

/**
 * @member {Number} weight_per_uom
 */
QuoteResponseLine.prototype['weight_per_uom'] = undefined;

/**
 * @member {Number} minimum_order_quantity
 */
QuoteResponseLine.prototype['minimum_order_quantity'] = undefined;

/**
 * @member {String} coo
 */
QuoteResponseLine.prototype['coo'] = undefined;

/**
 * @member {String} no_quote_classification
 */
QuoteResponseLine.prototype['no_quote_classification'] = undefined;

/**
 * @member {String} no_quote_other_reason
 */
QuoteResponseLine.prototype['no_quote_other_reason'] = undefined;

/**
 * @member {Date} will_advise_dt
 */
QuoteResponseLine.prototype['will_advise_dt'] = undefined;

/**
 * @member {Array.<module:model/QuoteResponseLineQuantity>} quantities
 */
QuoteResponseLine.prototype['quantities'] = undefined;

/**
 * @member {module:model/QuoteResponseAlternatePartInfo} alternate_nsn
 */
QuoteResponseLine.prototype['alternate_nsn'] = undefined;

/**
 * @member {module:model/QuoteResponseAlternatePartInfo} alternate_part_number
 */
QuoteResponseLine.prototype['alternate_part_number'] = undefined;

/**
 * @member {Array.<module:model/AdditionalCost>} additional_costs
 */
QuoteResponseLine.prototype['additional_costs'] = undefined;
var _default = exports["default"] = QuoteResponseLine;